module.exports = __webpack_public_path__ + "img/Nabumbugu_distribution_August_2017_4.f1bf48ce.jpg";